
import { Fragment } from 'vue-frag'
import availabilityConstants from '~/store/availability/-constants'
import requestOfferConstants from '~/store/requestOffer/-constants'
import modalConstants from '~/store/modal/-constants'
import MoleculeAvailabilitySpaceFilterResultCombinedSpace
  from '~/components/molecules/project/building/MoleculeAvailabilitySpaceFilterResultCombinedSpace.vue'
import { getElementHalfWidth } from '~/helpers/util';
import baseConstants from "~/store/base/-constants";

export default {
  name: 'MoleculeAvailabilitySpaceFilterResult',
  components: {
    MoleculeAvailabilitySpaceFilterResultCombinedSpace,
    Fragment
  },
  props: {
    displayData: {
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    },
    showHeader: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    engine3d() {
      return this.$engine3d || window.engine3d
    },
    listSpaceDetails() {
      return this.projectFeatures?.listSpaceDetails || ['sqm', 'people']
    },
    isAvailable() {
      return this.displayData.available
    },
    includeLeasedSpacesInResultsList() {
      return this.$store.state.availability.includeLeasedSpaces
    },
    shouldDisableAction() {
      return !this.isAvailable && !this.includeLeasedSpacesInResultsList
    },
    requestedSpaces() {
      return this.$store.state.requestOffer.spaces
    },
    spaceIsRequested() {
      return this.requestedSpaces.find((space) => space.id === this.displayData.id)
    },
    projectFeatures() {
      return this.$store.getters?.featuresForProject(this.activeProject)
    },
    disableList() {
      return this.projectFeatures?.disableMyList
    },
    isEmbedPath() {
      return this.$route.path.includes('/embed')
    },
    buildings() {
      return this.$store.state.project.project.buildings
    },
    floors() {
      return this.$store.state.project.project.floors
    },
    activeProject() {
      return this.$store.state.project.activeProject
    },
    combinedSpace() {
      return this.displayData.combined_space
    },
    canCombineWithAnotherSpace() {
      return this.displayData.combined_space_id
    },
    linkedSpace() {
      return this.displayData.linked_space
    },
    hasLinkedSpace() {
      return this.displayData.linked_space_id
    },
    storeFilters() {
      return this.$store.state.availability.filters
    },
    selectedSpace() {
      const space = { ...this.$store.state.building.space.spaceData }
      const building = this.buildings.find((b) => b.id === space.building_id)
      const floor = this.floors.find((f) => f.id === space.floor_id)
      space.building = building
      space.floor = floor
      return space
    },
    isSelectedSpace() {
      // console.log(this.displayData.id, this.selectedSpace.id, this.displayData.id === this.selectedSpace.id)
      return this.displayData.id === this.selectedSpace.id;
    },
    isMenuOpen() {
      return this.$store.state.base.isAvailabilityMenuOpen
    },
  },
  watch: {},
  mounted() {
  },
  methods: {
    highlightSpace() {
      if (this.selectedSpace.id === this.displayData.id) return;
      const { floor, space_code: spaceCode } = this.displayData
      if (this.selectedSpace.floor && this.selectedSpace.floor.code !== floor.code) return;
      const manager = this.engine3d.getClientManager()
      if (manager) {
        const spacesCode = spaceCode.split(';')
        manager.toggleHighlightSpace(
          floor.building.code.toLowerCase().trim(),
          floor.code.toLowerCase().trim(),
          spacesCode,
          this.displayData.available,
          true
        )
      }
    },
    unHighlightSpace() {
      if (this.selectedSpace.id === this.displayData.id) return;
      const { floor } = this.displayData
      const manager = this.engine3d.getClientManager()
      if (manager) {
        manager.toggleHighlightSpace(
          floor.building.code.toLowerCase().trim(),
          floor.code.toLowerCase().trim(),
          [],
          this.displayData.available,
          true
        )
      }
    },
    selectSpace() {
      const { floor, space_code: spaceCode, linked_space: linkedSpace } = this.displayData

      this.$store.dispatch('building/viewSpace', {
        space: spaceCode,
        building: floor.building.code,
        floor: floor.code,
        spaceData: this.displayData
      })

      this.$store.dispatch(
        availabilityConstants.withNamespace(availabilityConstants.action.UPDATE_FILTERS),
        {
          buildingId: floor.building.id,
          floorId: floor.id,
          floorNo: floor.no,
        }
      )

      if (window.innerWidth <= 900) {
        this.$store.dispatch(baseConstants.withNamespace(baseConstants.action.CLOSE_SIDEBAR_MOBILE_STATE))
        this.$store.dispatch(baseConstants.withNamespace(baseConstants.action.CLOSE_FILTER))
      }

      const manager = this.engine3d.getClientManager()
      if (manager) {
        manager.showPinsByCategory('none')
        if (linkedSpace) {
          const linkedBuildingCodes = this.buildings.filter(e => e.id === linkedSpace.building_id);
          if (linkedBuildingCodes.length) {
            manager.hideBuildingCase(linkedBuildingCodes[0].code, floor.code);
          }
        }
      }
    },
    unselectSpace() {
      const { floor } = this.displayData
      const manager = this.engine3d.getClientManager()
      if (manager) {
        const elementHalfWidth = getElementHalfWidth('#organism-sidebar-project');
        const offsetValueX = (this.isMenuOpen && window.innerWidth > 900) ? -elementHalfWidth : 0;
        const offsetValueY = window.innerWidth <= 900 ? -50 : 0;
        const offsetTarget = { x: offsetValueX, y: offsetValueY };
        manager.cameraFocusTo(floor?.building?.code.toLowerCase(), floor?.code, offsetTarget);
      }
      this.$store.dispatch('building/viewSpace', {})

      if (window.innerWidth <= 900) {
        this.$store.dispatch(baseConstants.withNamespace(baseConstants.action.CLOSE_SIDEBAR_MOBILE_STATE))
        this.$store.dispatch(baseConstants.withNamespace(baseConstants.action.CLOSE_FILTER))
      }
    },
    addSpaceToCart(e) {
      e.preventDefault();
      e.stopPropagation();
      const space = {
        ...this.displayData
      }
      space.building = this.buildings.find((b) => b.id === this.displayData.building_id);
      space.floor = this.floors.find((f) => f.id === this.displayData.floor_id);

      if (window && 'analyticsLayer' in window) {
        window.analyticsLayer.send({
          event: 'add_space_to_list',
          payload: {
            zone: 'building',
            space
          }
        })
      }
      this.$store.dispatch(
        requestOfferConstants.withNamespace(requestOfferConstants.action.ADD_SPACE),
        space
      )
    },
    addSpaceToCartAndOpenRequestOffer(e) {
      e.preventDefault();
      e.stopPropagation();
      const space = {
        ...this.displayData
      }
      space.building = this.buildings.find((b) => b.id === this.displayData.building_id);
      space.floor = this.floors.find((f) => f.id === this.displayData.floor_id);

      if (window && 'analyticsLayer' in window) {
        window.analyticsLayer.send({
          event: 'request_offer_open',
          payload: {
            zone: 'building'
          }
        })
      }
      this.$store.dispatch(
        requestOfferConstants.withNamespace(requestOfferConstants.action.ADD_SPACE),
        space
      )
      this.$store.dispatch(modalConstants.withNamespace(modalConstants.action.CHANGE_MODAL_STATE), {
        showModal: true,
        modalType: 'request-offer'
      })
      document.body.classList.add('disable-scroll')
    },
    removeSpaceFromCart(e) {
      e.preventDefault();
      e.stopPropagation();
      const space = {
        ...this.displayData
      }
      space.building = this.buildings.find((b) => b.id === this.displayData.building_id);
      space.floor = this.floors.find((f) => f.id === this.displayData.floor_id);

      if (window && 'analyticsLayer' in window) {
        window.analyticsLayer.send({
          event: 'remove_space_from_list',
          payload: {
            zone: 'building',
            space
          }
        })
      }
      this.$store.dispatch(
        requestOfferConstants.withNamespace(requestOfferConstants.action.REMOVE_SPACE),
        space
      )
    },
    exploreSpace(e) {
      e.preventDefault();
      e.stopPropagation();
      const space = {
        ...this.displayData
      }
      space.building = this.buildings.find((b) => b.id === this.displayData.building_id);
      space.floor = this.floors.find((f) => f.id === this.displayData.floor_id);

      if (window && 'analyticsLayer' in window) {
        window.analyticsLayer.send({
          event: 'explore_space_trigger',
          payload: {
            zone: 'building',
            spaceCode: space.space_code,
            buildingCode: space.building.code,
            floorCode: space.floor.code,
          }
        })
      }
      if (!this.isEmbedPath) {
        this.$router.push({
          path: `/project/${this.activeProject}/space/${space.id}#building`
        })
      } else {
        this.$router.push({
          path: `/embed/${this.activeProject}/space/${space.id}`
        })
      }
    }
  }
}
